import React, { Component } from "react";
import { Card, Dimmer, Loader, Feed } from "semantic-ui-react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import * as HomeAction from "../homePage/homePageActions";
import "rc-pagination/assets/index.css";

class TopTenLikes extends Component {
  constructor(props) {
    super(props);

    this.onHandleChange = this.onHandleChange.bind(this);
  }

  componentDidMount() {
    const { homeActions } = this.props;
    homeActions.onGetTopTenLikedBookmarks();
  }

  onHandleChange(event, data) {
    const { history } = this.props;
    const websiteTitle = data.items.header.replace(/ /g, "-");
    const id = data.items.Id;
    history.push(`post/${id}/${websiteTitle}`, {
      bookmarkId: id,
      categoryName: data.items.categoryName,
      website: data.items.websiteURL
    });
  }

  renderTopTenBookmarks(topTenBookmarks) {
    if (topTenBookmarks && topTenBookmarks.length > 0) {
      return topTenBookmarks.map(bookmarks => {
        return (
          <Card
            key={bookmarks.UserBookmarks.Id}
            link
            fluid
            items={{
              Id: bookmarks.UserBookmarks.Id,
              header: bookmarks.UserBookmarks.StoryTitle,
              categoryName: bookmarks.UserBookmarks.CategoryName,
              websiteURL: bookmarks.UserBookmarks.URL
            }}
            onClick={this.onHandleChange}
          >
            <Card.Content>
              <Card.Header>{bookmarks.UserBookmarks.StoryTitle}</Card.Header>
              <Card.Meta>{bookmarks.UserBookmarks.URL}</Card.Meta>
              <Card.Description>
                {bookmarks.UserBookmarks.Description}
              </Card.Description>
            </Card.Content>
            <Card.Content extra>
              <div style={{ width: "100%" }}>
                <div style={{ float: "left" }}>
                  {bookmarks.UserBookmarks.CategoryName}
                </div>
                <div style={{ float: "right", display: "inline-flex" }}>
                  <div style={{ display: "flex" }}>
                    <i class="eye icon"></i> {bookmarks.UserBookmarks.Views}
                  </div>
                  <div style={{ paddingLeft: "15%", display: "flex" }}>
                    <i class="thumbs up outline icon"></i>
                    {bookmarks.Likes}
                  </div>
                </div>
              </div>
            </Card.Content>
          </Card>
        );
      });
    }
  }

  render() {
    const { isLoading, topTenLikedBookmarks } = this.props;
    return (
      <div style={{ width: "100%", display: "inline-block" }}>
        <div style={{ width: "100%", marginTop: "10px", float: "left" }}>
          <Dimmer.Dimmable dimmed={isLoading}>
            <div style={{ height: 20 }}>
              <Dimmer active={isLoading} inverted={true}>
                <Loader>Loading</Loader>
              </Dimmer>
            </div>

            <div style={{ width: "100%", display: "inline-flex" }}>
              <div style={{ width: "100%", wordWrap: "break-word" }}>
                <Card fluid>
                  <Card.Content>
                    <Card.Header>Top Ten Liked Boomarks</Card.Header>
                  </Card.Content>
                  <Card.Content extra>
                    <Feed>
                      <div style={{ width: "100%" }}>
                        {this.renderTopTenBookmarks(topTenLikedBookmarks)}
                      </div>
                    </Feed>
                  </Card.Content>
                </Card>
              </div>
            </div>
          </Dimmer.Dimmable>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ homePage }) => {
  const {
    isLoading,
    topTenLikedBookmarks,
    totalTopTenLikedBookmarks
  } = homePage;
  return {
    isLoading,
    topTenLikedBookmarks,
    totalTopTenLikedBookmarks
  };
};

const mapDispatchToProps = dispatch => {
  return {
    homeActions: bindActionCreators(HomeAction, dispatch)
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(TopTenLikes));
